import DiskCapacityBar from '../atoms/container/diskCapacityBar';
import DiskCapacityBarInfo from '../atoms/text/diskCapacityBarInfo';
import DiskCapacityBarMaxCapacity from '../atoms/text/diskCapacityBarMaxCapacity';
import DiskCapacityCloud from '../atoms/images/diskCapacityCloud';
import DiskCapacityContainer from '../atoms/container/diskCapacityContainer';
import DiskCapacityInfo from '../atoms/text/diskCapacityInfo';
import DiskCapacityInnerBar from '../atoms/container/diskCapacityInnerBar';
import DiskCapacityOuterBar from '../atoms/container/diskCapacityOuterBar';
import DiskCapacityTitle from '../atoms/text/diskCapacityTitle';
import Focus from '../../../shared/types/enums/focus';
import MainContainer from '../atoms/container/mainContainer';
import TranslationManager from '../../../shared/assets/locale/translationsManager';
import useBackKeyboard from '../../../shared/components/utils/hooks/useBackKeyboard';
import useMenu from '../../../shared/components/utils/hooks/useMenu';
import {
  focusSelector,
  setFocus,
} from '../../../shared/store/slices/focus.slice';
import { useAppDispatch, useAppSelector } from '../../../shared/store/hooks';
import { useEffect } from 'react';

const LITERALS = 'PAGES.SETTINGS.DISK';

function TDisk({
  days,
  quota,
  used,
}: {
  days: string;
  quota: number;
  used: number;
}) {
  const dispatch = useAppDispatch();
  const { focus } = useAppSelector(focusSelector);
  const menuFocused = focus === Focus.MENU;

  // Effect hooks

  useEffect(() => {
    dispatch(setFocus(Focus.DISK));
  }, []);

  // Keyboard hooks

  useBackKeyboard();

  useMenu(null, true);

  return (
    <MainContainer id={'diskContainer'}>
      <DiskCapacityContainer
        animation={menuFocused ? 'main-content-out' : 'main-content-in'}
        force={true}
      >
        <DiskCapacityTitle>
          {TranslationManager.get(`${LITERALS}.TITLE`)}
        </DiskCapacityTitle>
        <DiskCapacityInfo>
          {TranslationManager.get(`${LITERALS}.INFO`)}
          <br></br>
          <br></br>
          {TranslationManager.get(`${LITERALS}.DETAIL`, days)}
        </DiskCapacityInfo>
        <DiskCapacityBar>
          <DiskCapacityCloud />
          <DiskCapacityOuterBar>
            <DiskCapacityInnerBar
              animation={{ transition: 'width 0.3s' }}
              width={(used && quota && used / quota) || 0}
            />
            <DiskCapacityBarInfo id={'diskCapacityBarInfo'}>
              {TranslationManager.get(
                `${LITERALS}.BAR_INFO`,
                `${used || '  '}`
              )}
            </DiskCapacityBarInfo>
          </DiskCapacityOuterBar>
          <DiskCapacityBarMaxCapacity id={'diskCapacityBarMaxCapacity'}>
            {TranslationManager.get(
              `${LITERALS}.MAX_CAPACITY`,
              `${quota || '  '}`
            )}
          </DiskCapacityBarMaxCapacity>
        </DiskCapacityBar>
      </DiskCapacityContainer>
    </MainContainer>
  );
}

export default TDisk;
